import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f86aca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-3" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cargo", -1))
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "users",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            modelValue: _ctx.input.cargo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.cargo) = $event)),
            clearable: "",
            class: "m-0",
            placeholder: "Selecione um cargo...",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cargos, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nome,
                  value: item.nome
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.input.data,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.data) = $event)),
                type: "daterange",
                format: "DD/MM/YYYY",
                "value-format": "YYYY/MM/DD",
                class: "w-100",
                style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","height":"36px"},
                "start-placeholder": "inicial",
                "end-placeholder": "final",
                "default-value": [new Date(), new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}